/** Translation keys used in the Roles module */
export const enum RolesTextKey {
    RolesEditRole = 'RolesEditRole',
    RolesRoleDetails = 'RolesRoleDetails',
    RolesTableColumnHeaderPermission = 'RolesTableColumnHeaderPermission',
    RolesTableColumnHeaderView = 'RolesTableColumnHeaderView',
    RolesTableColumnHeaderCreate = 'RolesTableColumnHeaderCreate',
    RolesTableColumnHeaderEdit = 'RolesTableColumnHeaderEdit',
    RolesTableColumnHeaderDelete = 'RolesTableColumnHeaderDelete',
    RolesTableColumnHeaderExport = 'RolesTableColumnHeaderExport',
    RolesTableEmptyStateDescription = 'RolesTableEmptyStateDescription',
    RolesTableEmptyStateTitle = 'RolesTableEmptyStateTitle',
    RolesTableSearchPlaceholder = 'RolesTableSearchPlaceholder',
    RolesTableSelectedCount = 'RolesTableSelectedCount',
}
